<template>
  <v-list-item three-line @click="$emit('clicked')">
    <v-list-item-avatar class="ma-auto">
      <v-avatar color="primary" size="32">
        <span class="white--text">{{ title[0] }}</span>
      </v-avatar>
    </v-list-item-avatar>
    <v-list-item-content class="pa-0 ml-3">
      <v-list-item-title class="ma-0">{{ title }}</v-list-item-title>
      <v-list-item-subtitle v-if="isSubtitlePrice" class="caption ma-0">{{ subtitle | price }}</v-list-item-subtitle>
      <v-list-item-subtitle v-else class="caption ma-0">{{ subtitle }}</v-list-item-subtitle>
      <v-list-item-subtitle v-if="isTextPrice" class="caption ma-0">{{ text | price }}</v-list-item-subtitle>
      <v-list-item-subtitle v-else class="caption ma-0">{{ text }}</v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: 'ListItemAvatarTwoL',
  props: {
    title: {
      type: String,
      default: 'title'
    },
    subtitle: {
      default: ''
    },
    text: {
      default: ''
    },
    isSubtitlePrice: {
      type: Boolean,
      default: false
    },
    isTextPrice: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>

</style>